<script lang="ts" setup>
const currentOffer = useCurrentOfferState();
</script>

<template>
  <div>
    <tw-offer-info
      :is-editing="false"
      :is-logged-in="false"
      :is-users-own-housing="false"
      :user="currentOffer.user"
      :search="currentOffer.search"
      :housing="currentOffer.housing"
      :housing-id="currentOffer.housing.id"
      :offer="currentOffer"
    />
  </div>
</template>

<style lang="scss" scoped></style>
